// extracted by mini-css-extract-plugin
export default {"formSection":"formSection--b3zRK","background":"background--yt4hC","form":"form--Jm_rA"};